<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
      date_min: this.moment().startOf('day').add(1, 'day').format('YYYY-MM-DD'),
      date_max: this.moment().startOf('day').add(6, 'months').format('YYYY-MM-DD'),
    }
  },
  computed: {

  },
  created() {
    
  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      if(
        !this.item.MailingAddress ||
        !this.item.MailingCity ||
        !this.item.MailingStateOrProvince ||
        !this.item.MailingPostalCode ||
        !this.item.OwnerName ||
        !this.item.OwnerEmail ||
        !this.item.OwnerPhone ||
        !this.item.sign_company.occupancy ||
        !this.item.sign_company.dogs ||
        !this.item.sign_company.property_access ||
        (this.item.sign_company.property_access == 'Other' && !this.item.sign_company.property_access_other) ||
        !this.item.sign_company.schedule_date ||
        !this.item.sign_company.schedule_time ||
        !this.item.sign_company.schedule_preference ||
        !this.item.is_realtor ||
        !this.item.buying ||
        !this.item.has_realtor ||
        !this.item.referred_by ||
        (this.item.referred_by == 'referral' && !this.item.referred_name)
      ) {
        this.$noty.error("Please complete all of the required fields on this page before continuing.");
        this.loading = false;
        return;
      }
      this.$emit('setpage', 6);
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <!-- <i class="mdi mdi-message-outline h1 text-primary mb-3" data-aos="fade-zoom-in"></i> -->
        <img :src="formatImage('/fm/revinre-nc/clip art/Additional details.png')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Additional Details</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Next, we just need to collect a little more information about you and your property. First, we need your current mailing address for any marketing materials related to your property that we may need to send.</p>
      </div>
      <div class="row mb-5">
        <div class="col-sm-12" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-MailingAddress">Mailing address <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-MailingAddress" name="address" type="text" class="form-control" v-model="item.MailingAddress" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-MailingCity">Mailing city <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
            <input id="field-MailingCity" name="city" type="text" class="form-control" v-model="item.MailingCity" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-MailingStateOrProvince">Mailing state <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-MailingStateOrProvince" name="state" class="form-control" v-model="item.MailingStateOrProvince" required>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-MailingPostalCode">Mailing zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-MailingPostalCode" name="zip_code" type="text" class="form-control" v-model="item.MailingPostalCode" required>
            <small class="text-muted"></small>
          </div>
        </div>
      </div>

      <div class="text-center py-5">
        <Icon icon="ri:account-pin-box-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">Property Owners</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Property Owner means any person shown as the owner of the property on the last equalized assessment roll or otherwise known to be the owner of the property by the city council.</p>
      </div>
      <div class="row">
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-OwnerName">Owner name <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-OwnerName" name="name" type="text" class="form-control" v-model="item.OwnerName" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-OwnerEmail">Owner email <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-OwnerEmail" name="email" type="text" class="form-control" v-model="item.OwnerEmail" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-OwnerPhone">Owner phone <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <the-mask id="field-OwnerPhone" type="tel" class="form-control" v-model="item.OwnerPhone" :mask="['(###) ###-####']" required />
            <small class="text-muted"></small>
          </div>
        </div>
      </div>

      <hr>
      <h5>Additional Owners</h5>
      <p class="text-muted mb-3">Use this section to add any additional property owners.</p>
      <div v-for="(owner, owner_i) in item.Owners" :key="owner_i" class="row align-items-end">
        <div class="col-sm" data-aos="fade-zoom-in">
          <div class="form-group">
            <label :for="'field-oname'+owner_i">Owner name</label>
            <input :id="'field-oname'+owner_i" name="name" type="text" class="form-control" v-model="owner.name">
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm" data-aos="fade-zoom-in">
          <div class="form-group">
            <label :for="'field-oemail'+owner_i">Owner email</label>
            <input :id="'field-oemail'+owner_i" name="email" type="text" class="form-control" v-model="owner.email">
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm" data-aos="fade-zoom-in">
          <div class="form-group">
            <label :for="'field-ophone'+owner_i">Owner phone</label>
            <the-mask :id="'field-ophone'+owner_i" type="tel" class="form-control" v-model="owner.phone" :mask="['(###) ###-####']" />
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm _w-70 _w-m-70">
          <button class="btn btn-white mb-2" type="button" v-tippy content="Delete" @click="item.Owners.splice(owner_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
        </div>
      </div>
      <div class="mb-5">
        <button class="btn btn-revinre" type="button" @click="item.Owners.push({name: '', email: '', phone: ''})"><Icon icon="ri:add-line" height="18"></Icon> Add owner</button>
      </div>

      <div class="text-center py-5">
        <Icon icon="ri:calendar-event-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">Scheduling</h3>
        <p class="text-muted" data-aos="fade-zoom-in">The following information will be used to assist us in scheduling sign installation, professional photos, and other services for your property.</p>
        <p class="text-muted" data-aos="fade-zoom-in">Please ensure the property is ready for on-site services before the date/time you choose below. Unless told otherwise, upon submission, we will put it on the schedule. We do not provide staging, nor will we wait on-site for "prepping" (cleaning, moving items, moving cars, etc).</p>
        <p class="text-muted" data-aos="fade-zoom-in">Late-notice changes or cancellations may result in a cancellation fee of up to $40.</p>
      </div>
      <div class="row mb-5">
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-occupancy">Property occupied by : <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-occupancy" name="occupancy" class="form-control" v-model="item.sign_company.occupancy" required>
              <option value="">-- Select --</option>
              <option value="Tenant">Tenant</option>
              <option value="Owner">Owner</option>
              <option value="Vacant">Vacant</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-dogs">Are dogs present <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-dogs" name="dogs" class="form-control" v-model="item.sign_company.dogs" required>
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-property_access">How will the property be accessed <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-property_access" name="property_access" class="form-control" v-model="item.sign_company.property_access" required>
              <option value="">-- Select --</option>
              <option value="Meet occupant at property">Meet occupant at property</option>
              <option value="Meet assistant at property">Meet assistant at property</option>
              <option value="Lockbox">Lockbox</option>
              <option value="Other">Other</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div v-if="item.sign_company.property_access == 'Other'" class="col-sm-12" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-property_access_other">Describe how the property will be accessed <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-property_access_other" name="property_access_other" type="text" class="form-control" v-model="item.sign_company.property_access_other" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-schedule_date">Desired Date of Service <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-schedule_date" type="date" class="form-control" v-model="item.sign_company.schedule_date" :min="date_min" :max="date_max" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-schedule_time">Desired Time of Service <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-schedule_time" name="schedule_time" class="form-control" v-model="item.sign_company.schedule_time" required>
              <option value="">-- Select --</option>
              <option value="Any time">Any time</option>
              <option value="Morning">Morning</option>
              <option value="Afternoon">Afternoon</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-schedule_preference">Which is more important to you <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-schedule_preference" name="schedule_preference" class="form-control" v-model="item.sign_company.schedule_preference" required>
              <option value="">-- Select --</option>
              <option value="Date">Date</option>
              <option value="Time">Time</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
      </div>

      <div class="text-center py-5">
        <Icon icon="ri:chat-smile-3-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">Help us improve</h3>
        <p class="text-muted" data-aos="fade-zoom-in">The home selling and buying process is always changing. We are constantly trying to help ease the process in any way we can. Help us improve by answering a few questions.</p>
      </div>
      <div class="row mb-5">
        <div class="col-sm-12" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-is_realtor">Are you a licenced realtor in the region this property will be listed <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-is_realtor" name="is_realtor" class="form-control" v-model="item.is_realtor" required>
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-buying">Looking to buy a property <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-buying" name="buying" class="form-control" v-model="item.buying" required>
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-referred_by">How did you hear about us <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-referred_by" name="referred_by" class="form-control" v-model="item.referred_by" required>
              <option value="">-- Select --</option>
              <option value="phone call">Phone Call</option>
              <option value="text message">Text Message</option>
              <option value="television ad">Television Ad</option>
              <option value="radio ad">Radio Ad</option>
              <option value="internet ad">Internet Ad</option>
              <option value="facebook">Facebook</option>
              <option value="instagram">Instagram</option>
              <option value="event">Event</option>
              <option value="mail brochure">Mail - Brochure</option>
              <option value="mail postcard">Mail - Postcard</option>
              <option value="referral">Referral from another client</option>
              <option value="repeat client">Repeat Client</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div v-if="item.referred_by == 'referral'" class="col-sm-4" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-referred_name">Who referred you <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="field-referred_name" name="referred_name" type="text" class="form-control" v-model="item.referred_name" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-12" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-has_realtor">Are you currently working with a realtor <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="field-has_realtor" name="has_realtor" class="form-control" v-model="item.has_realtor" required>
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 4)" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
